import Cookies from 'js-cookie'

const userKey = 'logined_user'

export function getUser() {
  let cookie = Cookies.get(userKey);
  if (cookie) {
    return JSON.parse(cookie);
  } else {
    return null
  }
}

export function setUser(loginUser) {
  //设置30天后过期
  var cacheDays = 30;
  Cookies.set(userKey, loginUser, {
    expires: cacheDays
  })
}

export function removeUser() {
  Cookies.remove(userKey)
}

export function getToken() {
  let user = getUser();
  if (user && user.token) {
    return user.token;
  } else {
    return null;
  }
}

export function loggedIn() {
  let cookie = getUser();
  if (cookie) {
    return true;
  } else {
    return false;
  }
}